<template>
  <div class="release-notes">
    <div class="release-notes-container">
      <template v-if="releaseNotes.length > 0">
      <b-carousel
          id="release-notes-carousel"
          controls
          :indicators="releaseNotes.length > 1"
          :interval="0"
          no-wrap
          no-touch
          no-keyboard
          class="custom-carousel"
      >
        <b-carousel-slide
            v-for="(note, index) in filteredReleaseNotes"
            :key="index"
        >
          <template #img>
            <div class="content carousel-slide-content" v-html="note.userCommunication"></div>
          </template>
        </b-carousel-slide>
      </b-carousel>
      </template>
      <template v-else>
        <div class="no-release-notes-message">
          <p>There are no recent releases available.</p>
          <!-- or alternatively: -->
          <!-- <p>No recent releases to display.</p> -->
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'ReleaseNotes',
  components:{},
  props:{},
  watch:{
      handler() {
        this.getReleaseNotes();
      },
      deep: true,
      immediate: true,
  },
  data: () => ({
    slide: 0,
    releaseNotes: [],
    loggedInTimestamp:null,
  }),
  computed:{
    filteredReleaseNotes() {
      if (!this.loggedInTimestamp) return [];

      return this.releaseNotes.filter(note => {
        const noteStartTime = new Date(note.startTimestamp);
        const noteExpiryTime = new Date(noteStartTime);
        noteExpiryTime.setDate(noteExpiryTime.getDate() +this.$store.state.user.userRoleRestriction.releaseNotesShowdays ); // 30 days expiry
        console.log("user time:",this.loggedInTimestamp,"compare time:",noteExpiryTime,"comparison",this.loggedInTimestamp < noteExpiryTime);

        return this.loggedInTimestamp < noteExpiryTime;
      });
    }
  },
  mounted() {
    this.getReleaseNotes();
    this.$nextTick(() => {
      const carouselEl = document.getElementById("release-notes-carousel");

      // Find the previous and next buttons
      const prevBtn = carouselEl.querySelector(".carousel-control-prev");
      const nextBtn = carouselEl.querySelector(".carousel-control-next");

      // Remove existing click behavior
      prevBtn.onclick = (e) => {
        // Only trigger if clicked on icon itself
        if (e.target.classList.contains("carousel-control-prev-icon")) {
          this.prevSlide();
        } else {
          e.stopPropagation();
        }
      };

      nextBtn.onclick = (e) => {
        if (e.target.classList.contains("carousel-control-next-icon")) {
          this.nextSlide();
        } else {
          e.stopPropagation();
        }
      };
    });
  },
  methods:{
    prevSlide() {
      this.slide = (this.slide - 1 + this.releaseNotes.length) % this.releaseNotes.length;
    },
    nextSlide() {
      this.slide = (this.slide + 1) % this.releaseNotes.length;
    },
    getReleaseNotes() {
      console.log('method called',this.$store.state.user);
      const url = "/api/user-release";
      const url1 = "/api/session-log";
      axios.get(url1).then(resp =>{
        console.log("resp",resp.data);
        const timestampMs = resp.data[0].login_timestamp; // Use the correct property name from your example

        // Create a Date object directly from the milliseconds timestamp
        const loginDate = new Date(timestampMs);

        this.loggedInTimestamp = loginDate;
      }).catch(error => {
        console.error("Error fetching url1:", error);
      });

      axios.get(url).then(response => {
        console.log("response", response.data);
        const roleName = this.$store.state.roleName; // Current user's role

        // Filter release notes where the roleArray includes the current user's role
        this.releaseNotes = response.data.filter(note =>
            note.roleArray && note.roleArray.includes(roleName)
        );
      }).catch(error => {
        console.error("Error fetching release notes:", error);
      });
    }
  },
}
</script>

<style scoped>
.no-release-notes-message {
  padding: 20px;
  text-align: center;
  color: #666;
  font-style: italic;
}
.release-notes {
  border: solid 1px black;
  margin: 2% auto;
  max-width: 90%;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  max-height: calc(100vh - 100px);
}

.release-notes-container {
  text-align: center;
  padding: 20px;
}

.video-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.video-container video {
  margin-top: 20px;
  width: 100%;
  max-width: 800px;
  border-radius: 8px;
}

.content {
  text-align: left;
  max-width: 800px;
  margin: auto;
  padding: 20px;
  background: #f4f3f9;
  border: 2px solid aliceblue;
  border-radius: 8px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

/* Custom carousel styling */
.custom-carousel {
  position: relative;
  max-width: 900px; /* Slightly wider than content */
  margin: 20px auto;
  touch-action: none; /* Disable swipe gestures */
}

/* Indicators styling */
.custom-carousel >>> .carousel-indicators {
  position: absolute;
  bottom: -30px;
  left: 0;
  right: 0;
  margin: 0;
  justify-content: center;
}

.custom-carousel >>> .carousel-indicators li {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin: 0 5px;
  background-color: rgba(0, 0, 0, 0.5);
}

.custom-carousel >>> .carousel-indicators li.active {
  background-color: #007bff;
}

/* Controls (arrows) styling */
.custom-carousel >>> .carousel-control-prev,
.custom-carousel >>> .carousel-control-next {
  pointer-events: none; /* disables click on full area */
}

.custom-carousel >>> .carousel-control-prev {
  left: -50px;
}

.custom-carousel >>> .carousel-control-next {
  right: -50px;
}

.custom-carousel >>> .carousel-control-prev-icon,
.custom-carousel >>> .carousel-control-next-icon {
  background-color:#00F9F9;
  border-radius: 2px;
  width: 20px;
  height: 20px;
  pointer-events: auto;
}

h3, h4 {
  margin-top: 20px;
}

ul {
  padding-left: 20px;
}

.sub-list {
  padding-left: 20px;
  list-style-type: circle;
}
</style>